module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#filter",
      toString: function () {
        return this.url;
      }
    }